// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".challenges_challenges__1VvN4 {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background-color: var(--black-10);\n  border-radius: 8px 8px;\n}\n.challenges_challenges__1VvN4 .challenges_swords__3vN3I {\n  width: 150px;\n  height: 150px;\n  fill: var(--black-30);\n}\n\n.challenges_challengeInfoHeading__1pBVZ {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n.challenges_challengeInfoHeading__1pBVZ svg {\n  position: absolute;\n  left: 0.5rem;\n}", ""]);
// Exports
exports.locals = {
	"challenges": "challenges_challenges__1VvN4",
	"swords": "challenges_swords__3vN3I",
	"challengeInfoHeading": "challenges_challengeInfoHeading__1pBVZ"
};
module.exports = exports;
